"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "sortTargetsByPriority", {
    enumerable: true,
    get: function() {
        return sortTargetsByPriority;
    }
});
function sortTargetsByPriority(targets) {
    return targets.sort((a, b)=>{
        return (b.priority ?? 0) - (a.priority ?? 0);
    });
}
